import { ID } from 'shared/types/id';
import { TaskType } from 'shared/types/task-base';

// Deliberately independent of `user.settings.upcoming.*`, which the list view keeps owning.
export type UpcomingCalendarViewOptions = {
  hiddenTaskTypes: TaskType[];
  // Carries `lifeAreaOtherID` to hide items that resolve to no life area at all.
  hiddenLifeAreaIds: ID[];
  hiddenCalendarIds: ID[];
  // Panel section ids in the order the user dragged them; unknown ids are ignored on read.
  sectionOrder: ID[];
  hideFocusBlocks: boolean;
  hideGoalDeadlines: boolean;
  hideExternalCalendarEvents: boolean;
  hideCompleted: boolean;
};

export const defaultUpcomingCalendarViewOptions: UpcomingCalendarViewOptions = {
  hiddenTaskTypes: [],
  hiddenLifeAreaIds: [],
  hiddenCalendarIds: [],
  sectionOrder: [],
  hideFocusBlocks: false,
  hideGoalDeadlines: false,
  hideExternalCalendarEvents: false,
  hideCompleted: false,
};
